import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component ensuring window scroll position resets to (0, 0)
 * on every client-side route navigation across the application.
 */
export const ScrollToTop = () => {
    const { pathname, search, hash } = useLocation();

    useEffect(() => {
        // Prevent browser's default scroll restoration from fighting SPA navigation
        if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    useEffect(() => {
        if (hash) {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                return;
            }
        }

        // Instantly reset viewport to top when route changes
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
    }, [pathname, search, hash]);

    return null;
};
